import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "driver.js/dist/driver.css";
import App from "./App.tsx";

import "./index.css";

import { AppProvider } from "./context/AppContext.tsx";

import { PartnersDatContextProvider } from "./context/PartnersDataContext.tsx";
import { SimplePaymentDataContextProvider } from "./context/SimplePaymentDataContext.tsx";
import { WalletFundContextProvider } from "./context/WalletFundContext.tsx";
import { XFlowPartnerContextProvider } from "./context/XFlowPartners.tsx";
// import { XFlowVbanContextContextProvider } from "./context/XFlowVbanContext.tsx";

import { Provider } from "react-redux";
import { store } from "./store/index.ts";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppProvider>
      <PartnersDatContextProvider>
        <SimplePaymentDataContextProvider>
          <WalletFundContextProvider>
            <XFlowPartnerContextProvider>
              <Provider store={store}>
                <App />
              </Provider>
            </XFlowPartnerContextProvider>
          </WalletFundContextProvider>
        </SimplePaymentDataContextProvider>
      </PartnersDatContextProvider>
    </AppProvider>
  </StrictMode>,
);
